import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY, DOCUMENT_NO_MAXLENGTH } from '../constants';
import { apiProvider } from '../api';
import dayjs from 'dayjs';

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		DealerKvps: [],
		DocumentTypes: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit: {
		DokladcrId: null as number | null,
		DokladPfx: null as string | null,
		DokladNr: null as string | null,
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		DokladPfxOd: null as string | null,
		DokladPfxDo: null as string | null,
		DokladNrOd: null as number | null,
		DokladNrDo: null as number | null,
		DokladPfxUnqPrp: null as boolean | null,
		DealerKvpsId: null as number | null,
		DocumentType: null as string | null,
		StartDate: null as Date | null,
		EditPracIdText: null as string | null,
		VstupPracIdText: null as string | null,
		CurrentCount: null as number | null,
	},
	localState: {
		startDatePickerOptions: { disabledDate(time: Date) { return dayjs(time).isBefore(dayjs(dayjs().add(-1, 'day'))); } },
		docNumberMaxLength: DOCUMENT_NO_MAXLENGTH,
	},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
